export default __webpack_public_path__ + "static/media/img-10.99794218.jpg";